import React from 'react';
import AltLayout from 'Nori/Layout/AltLayout';
import Button from 'Nori/Button';
import Image from 'Nori/Image';
import SplitContent from 'Custom/Split/SplitContent';
import AjustableImage from 'Custom/AjustableImage';
import RichText from 'Custom/RichText';
import Hero from 'Nori/Hero/HeroFull';
import Container from 'Nori/Container';
import FAQ from 'Custom/FAQ';
import FAQHeader from 'Custom/FAQ/FAQHeader';
import FinderSimple from 'Custom/Finder/FinderSimple';
import ItemBreakpoint from 'Custom/ItemBreakpoint/index';
import { FAQ_HOME_QUESTIONS } from 'Utils/es/home-questions';
import { SPANISH_JOB_CODE } from 'Custom/Footer/es/Footer.utils';
import HAND_IMAGE_DESKTOP from 'Images/misc/hand-desktop.webp';
import HAND_IMAGE_MOBILE from 'Images/misc/hand-mobile.webp';
import FANTASY_IMAGE from 'Images/misc/fantasy-es.svg';
import FANTASY_IMAGE_MOBILE from 'Images/misc/fantasy-mobile-es.svg';
import HERO_BG_IMAGE from 'Images/background/dark-blue-home.png';
import WHITE_MARBLE_BG_IMAGE from 'Images/misc/common-ques-desktop.png';
import WHITE_MARBLE_BG_IMAGE_MOBILE from 'Images/misc/common-ques-mobile.png';
import HERO_BG_IMAGE_MOBILE from 'Images/background/blue-bg-mobile.png';
import CIRCLE_IMAGE_DESKTOP from 'Images/misc/circle-arrows-desktop.webp';
import CIRCLE_IMAGE_MOBILE from 'Images/misc/circle-arrows-mobile.webp';
import HAND_SHORT_IMAGE from 'Images/misc/hand-shadow-short.png';
import PLUS_IMAGE_DESKTOP from 'Images/misc/plus-sign-desktop.webp';
import PLUS_IMAGE_MOBILE from 'Images/misc/plus-sign-mobile.webp';
import EffectiveSplit from 'Custom/EffectiveSplit/effectiveSplitES';
import ExternalIcon from 'Images/brand-icons/external-icon.svg';
import styles from 'styles/pages/home.module.scss';

const HEAD = {
  title: 'NEXPLANON® (etonogestrel implant) 68 mg Radiopaque | Official Site',
  description:
    'NEXPLANON® (etonogestrel implant) 68 mg Radiopaque is a hormone-releasing birth control implant used by women to prevent pregnancy up to 5 years.',
  keywords:
    'Nexplanon, Birth Control Implant, Nexplanon Birth Control, What is Nexplanon, Anti Pregnancy Arm Implant',
};

const HeroBannerContentDesktop = () => {
  return (
    <div className={styles['content-wrap']} data-qa-tag="home-hero-content">
      <div className={styles.topContent} data-qa-tag="home-top-content">
        <p>
          <span
            className={styles.topColoredText}
            data-qa-tag="home-title-nexplanon"
          >
            NEXPLANON{' '}
          </span>
          <span data-qa-tag="home-hero-title" className={styles.topTextLg}>
            ha sido aprobado
          </span>
        </p>
        <p>
          <span data-qa-tag="home-hero-title-for" className={styles.topTextSm}>
            para un período de hasta{' '}
          </span>
          <span
            data-qa-tag="home-five-years-content"
            className={styles.topTextLg}
          >
            5 años
          </span>
        </p>
        <p>
          <span data-qa-tag="3rd-line-content" className={styles.topTextLg}>
            para prevenir el embarazo
          </span>
        </p>
      </div>
      <FANTASY_IMAGE
        data-qa-tag="home-hero-title-image"
        className={styles.fantasyImage}
      />
      <div data-qa-tag="home-bottom-content" className={styles.bottomContent}>
        <p data-qa-tag="home-hero-description" className={styles.bottomTextLg}>
          NEXPLANON es un anticonceptivo recetado de actividad prolongada para
          <br />
          la prevención del embarazo en mujeres que dura hasta 5 años.
          <sup>†</sup>
        </p>
        <p data-qa-tag="home-hero-caption" className={styles.bottomTextSm}>
          <sup>†</sup>NEXPLANON se debe extraer hacia el final del quinto año.
        </p>
      </div>
      <Button
        data-qa-tag="home-hero-button"
        href="/how-does-nexplanon-work/"
        data-design-type="clickAction"
        data-design-category="button_vd"
        data-design-action="Button"
        data-design-label="Learn How NEXPLANON Works"
        data-design-nori_id="Hero"
        data-design-module_name="MEET NEXPLANON"
        data-design-module_no="01"
        type="primary2"
      >
        Conozca cómo funciona NEXPLANON
      </Button>
      <Button
        data-qa-tag="home-redirection-to-english-button"
        href="/"
        data-design-type="clickAction"
        data-design-category="button_vd"
        data-design-action="Button"
        data-design-label="Find a Doctor"
        data-design-nori_id="Inline Content"
        data-design-module_name="NEXPLANON works by preventing ovulation"
        data-design-module_no="03"
        type="simple3"
      >
        Sitio en Ingles
        <ExternalIcon />
      </Button>
    </div>
  );
};
const HeroBannerContentMobile = () => {
  return (
    <div className={styles['content-wrap']} data-qa-tag="home-hero-content">
      <div className={styles.topContent} data-qa-tag="home-top-content">
        <p>
          <span
            className={styles.topColoredText}
            data-qa-tag="home-title-nexplanon"
          >
            NEXPLANON{' '}
          </span>
          <span data-qa-tag="home-hero-title-1" className={styles.topTextLg}>
            ha sido
            <br />
            aprobado para un período de
            <br />
          </span>
          <span data-qa-tag="home-hero-title-2" className={styles.topTextSm}>
            hasta{' '}
          </span>
          <span data-qa-tag="home-hero-title-3" className={styles.topTextLg}>
            5{' '}
          </span>
          <span data-qa-tag="home-hero-title-4" className={styles.topTextSm}>
            años
            <br />
          </span>
          <span data-qa-tag="home-hero-title-5" className={styles.topTextSm}>
            para prevenir el embarazo
          </span>
        </p>
      </div>
      <FANTASY_IMAGE_MOBILE
        data-qa-tag="home-hero-title-image"
        className={styles.fantasyImage}
      />
      <div data-qa-tag="home-bottom-content" className={styles.bottomContent}>
        <p data-qa-tag="home-hero-description" className={styles.bottomTextLg}>
          NEXPLANON es un anticonceptivo recetado de<br></br>actividad
          prolongada para la prevención del
          <br />
          embarazo en mujeres que dura hasta 5 años.<sup>†</sup>
        </p>
        <p data-qa-tag="home-hero-caption" className={styles.bottomTextSm}>
          <sup>†</sup>NEXPLANON se debe extraer hacia el final
          <br /> del quinto año.
        </p>
      </div>
      <Button
        data-qa-tag="home-hero-button"
        href="/how-does-nexplanon-work/"
        data-design-type="clickAction"
        data-design-category="button_vd"
        data-design-action="Button"
        data-design-label="Learn How NEXPLANON Works"
        data-design-nori_id="Hero"
        data-design-module_name="MEET NEXPLANON"
        data-design-module_no="01"
        type="primary2"
      >
        Conozca cómo funciona
        <br /> NEXPLANON
      </Button>
      <Button
        data-qa-tag="home-redirection-to-english-button"
        href="/"
        data-design-type="clickAction"
        data-design-category="button_vd"
        data-design-action="Button"
        data-design-label="Find a Doctor"
        data-design-nori_id="Inline Content"
        data-design-module_name="NEXPLANON works by preventing ovulation"
        data-design-module_no="03"
        type="simple3"
      >
        Sitio en Ingles
        <ExternalIcon />
      </Button>
    </div>
  );
};

export default function HomeSpanish() {
  return (
    <AltLayout head={HEAD} jobCode={SPANISH_JOB_CODE}>
      <div data-qa-tag="home-hero-wrapper" className={styles.heroWrapper}>
        <ItemBreakpoint breakpoint={'lg'}>
          <Hero data-qa-tag="home-hero-bg-image-desktop" image={HERO_BG_IMAGE}>
            <HeroBannerContentDesktop></HeroBannerContentDesktop>
          </Hero>
          <Hero
            data-qa-tag="home-hero-bg-image-mobile"
            image={HERO_BG_IMAGE_MOBILE}
          >
            <HeroBannerContentMobile></HeroBannerContentMobile>
          </Hero>
        </ItemBreakpoint>
      </div>

      <section
        className={styles.handSplitComponent}
        data-qa-tag="home-preventing-ovulation-section"
      >
        <SplitContent
          data-qa-tag="home-preventing-ovulation-wrapper-split"
          backgroundColor={'colored'}
          id="nexplanon-works-preventing-ovulation"
          data-design-visible="visible_vd"
          data-design-type="module"
          data-design-nori_id="Inline Content"
          data-design-module_name="NEXPLANON works by preventing ovulation"
          data-design-module_no="03"
          padding="no_padding"
        >
          <ItemBreakpoint breakpoint="md">
            <AjustableImage
              data-qa-tag="home-preventing-ovulation-desktop-image"
              size="full"
              image={{
                src: HAND_IMAGE_DESKTOP,
                style: { width: 376 },
                alt: '',
              }}
            />
            <AjustableImage
              data-qa-tag="home-preventing-ovulation-mobile-image"
              size="full"
              image={{ src: HAND_IMAGE_MOBILE, style: { width: 187 }, alt: '' }}
            />
          </ItemBreakpoint>
          <>
            <RichText data-qa-tag="home-preventing-ovulation-content-wrapper">
              <h2 className="mb" data-qa-tag="home-preventing-ovulation-title">
                NEXPLANON funciona impidiendo la ovulación
              </h2>
              <p
                className="body-text"
                data-qa-tag="home-preventing-ovulation-description"
              >
                NEXPLANON funciona mediante el uso de una hormona que impide que
                su ovario libere un óvulo y evita que los espermatozoides
                lleguen al óvulo. También modifica el revestimiento de su útero.
              </p>
            </RichText>
            <div className={styles.btnWrapper}>
              <Button
                data-qa-tag="home-preventing-ovulation-button"
                href="/what-is-nexplanon/#find-a-doctor"
                data-design-type="clickAction"
                data-design-category="button_vd"
                data-design-action="Button"
                data-design-label="Find a Doctor"
                data-design-nori_id="Inline Content"
                data-design-module_name="NEXPLANON works by preventing ovulation"
                data-design-module_no="03"
              >
                Encontrar un médico
              </Button>
              <Button
                data-qa-tag="home-redirection-to-english-button"
                href="/"
                data-design-type="clickAction"
                data-design-category="button_vd"
                data-design-action="Button"
                data-design-label="Find a Doctor"
                data-design-nori_id="Inline Content"
                data-design-module_name="NEXPLANON works by preventing ovulation"
                data-design-module_no="03"
                type="simple2"
              >
                Sitio en Ingles
                <ExternalIcon />
              </Button>
            </div>
          </>
        </SplitContent>
      </section>

      <EffectiveSplit
        data-design-module_no="04"
        moduleNumber={'04'}
      ></EffectiveSplit>

      <SplitContent
        data-qa-tag="home-reversible-wrapper-split"
        backgroundColor={'colored'}
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="it's reversible"
        data-design-module_no="05"
      >
        <ItemBreakpoint breakpoint="md">
          <AjustableImage
            data-qa-tag="home-reversible-image-desktop"
            size="full"
            image={{
              src: CIRCLE_IMAGE_DESKTOP,
              style: { width: 292 },
              alt: '',
            }}
          />
          <AjustableImage
            data-qa-tag="home-reversible-image-mobile"
            size="full"
            image={{ src: CIRCLE_IMAGE_MOBILE, alt: '' }}
          />
        </ItemBreakpoint>
        <>
          <RichText data-qa-tag="home-reversible-content-wrapper">
            <h2 className="mb" data-qa-tag="home-reversible-title">
              Es reversible
            </h2>
            <p className="body-text" data-qa-tag="home-reversible-description">
              NEXPLANON es reversible. Si usted cambia de planes, un profesional
              de la salud capacitado lo puede extraer en cualquier momento
              durante el período de 5 años.
            </p>
          </RichText>
          <ItemBreakpoint breakpoint="md">
            <div className={styles.btnWrapper}>
            <Button
              data-qa-tag="home-reversible-button"
              href="/removal/"
              data-design-type="clickAction"
              data-design-category="button_vd"
              data-design-action="Button"
              data-design-label="Learn More About Removal"
              data-design-nori_id="Inline Content"
              data-design-module_name="it's reversible"
              data-design-module_no="05"
            >
              Obtenga más información sobre la extracción
            </Button>
              <Button
                data-qa-tag="home-redirection-to-english-button"
                href="/"
                data-design-type="clickAction"
                data-design-category="button_vd"
                data-design-action="Button"
                data-design-label="Find a Doctor"
                data-design-nori_id="Inline Content"
                data-design-module_name="NEXPLANON works by preventing ovulation"
                data-design-module_no="03"
                type="simple2"
              >
                Sitio en Ingles
                <ExternalIcon />
              </Button>
            </div>
            <div className={styles.btnWrapper}>
            <Button
              data-qa-tag="home-reversible-button"
              href="/removal/"
              data-design-type="clickAction"
              data-design-category="button_vd"
              data-design-action="Button"
              data-design-label="Learn More About Removal"
              data-design-nori_id="Inline Content"
              data-design-module_name="it's reversible"
              data-design-module_no="05"
            >
              Obtenga más información
              <br /> sobre la extracción
            </Button>
              <Button
                data-qa-tag="home-redirection-to-english-button"
                href="/"
                data-design-type="clickAction"
                data-design-category="button_vd"
                data-design-action="Button"
                data-design-label="Find a Doctor"
                data-design-nori_id="Inline Content"
                data-design-module_name="NEXPLANON works by preventing ovulation"
                data-design-module_no="03"
                type="simple2"
              >
                Sitio en Ingles
                <ExternalIcon />
              </Button>
            </div>
          </ItemBreakpoint>
        </>
      </SplitContent>

      <SplitContent
        data-qa-tag="home-side-effects-wrapper-split"
        reverse
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Inline Content"
        data-design-module_name="side effects of NEXPLANON"
        data-design-module_no="06"
      >
        <ItemBreakpoint breakpoint="md">
          <AjustableImage
            data-qa-tag="home-side-effects-image-desktop"
            size="full"
            image={{ src: PLUS_IMAGE_DESKTOP, style: { width: 292 }, alt: '' }}
          />
          <AjustableImage
            data-qa-tag="home-side-effects-image-mobile"
            size="full"
            image={{ src: PLUS_IMAGE_MOBILE, alt: '' }}
          />
        </ItemBreakpoint>
        <>
          <RichText data-qa-tag="home-side-effects-content-wrapper">
            <h2 data-qa-tag="home-side-effects-title" className="mb">
              Efectos secundarios de NEXPLANON
            </h2>
            <p className="body-text" data-qa-tag="side-effects-description">
              El efecto secundario más frecuente de NEXPLANON es un cambio en su
              patrón normal de sangrado menstrual. En estudios realizados, 1 de
              cada 10 mujeres dejó de usar NEXPLANON por un cambio desfavorable
              en su patrón de sangrado. Además de cambios en los patrones de
              sangrado menstrual, otros efectos secundarios frecuentes que
              causaron que las mujeres dejaran de usar el implante incluyen
              cambios del estado de ánimo, aumento de peso, dolores de cabeza,
              acné y estado de ánimo depresivo.
            </p>
          </RichText>
          <ItemBreakpoint breakpoint="md">
            <div className={styles.btnWrapper}>
              <Button
                data-qa-tag="home-side-effects-button"
                href="/es-us/efectos-secundarios/"
                data-design-type="clickAction"
                data-design-category="button_vd"
                data-design-action="Button"
                data-design-label=" Side Effects of NEXPLANON"
                data-design-nori_id="Inline Content"
                data-design-module_name="side effects of NEXPLANON"
                data-design-module_no="06"
              >
                Efectos secundarios de NEXPLANON
              </Button>
              <Button
                data-qa-tag="home-redirection-to-english-button"
                href="/"
                data-design-type="clickAction"
                data-design-category="button_vd"
                data-design-action="Button"
                data-design-label="Find a Doctor"
                data-design-nori_id="Inline Content"
                data-design-module_name="NEXPLANON works by preventing ovulation"
                data-design-module_no="03"
                type="simple2"
              >
                Sitio en Ingles
                <ExternalIcon />
              </Button>
            </div>
            <div className={styles.btnWrapper}>
              <Button
                data-qa-tag="home-side-effects-button"
                href="/es-us/efectos-secundarios/"
                data-design-type="clickAction"
                data-design-category="button_vd"
                data-design-action="Button"
                data-design-label=" Side Effects of NEXPLANON"
                data-design-nori_id="Inline Content"
                data-design-module_name="side effects of NEXPLANON"
                data-design-module_no="06"
              >
                Efectos secundarios de
                <br /> NEXPLANON
              </Button>
              <Button
                data-qa-tag="home-redirection-to-english-button"
                href="/"
                data-design-type="clickAction"
                data-design-category="button_vd"
                data-design-action="Button"
                data-design-label="Find a Doctor"
                data-design-nori_id="Inline Content"
                data-design-module_name="NEXPLANON works by preventing ovulation"
                data-design-module_no="03"
                type="simple2"
              >
                Sitio en Ingles
                <ExternalIcon />
              </Button>
            </div>
          </ItemBreakpoint>
        </>
      </SplitContent>

      <section
        className={styles.splitAccordion}
        data-design-visible="visible_vd"
        data-design-type="module"
        data-design-nori_id="Accordion"
        data-design-module_name="Common questions"
        data-design-module_no="07"
        data-qa-tag="common-questions-section"
        style={{
          '--desktop-bg': `url(${WHITE_MARBLE_BG_IMAGE.src})`,
          '--mobile-bg': `url(${WHITE_MARBLE_BG_IMAGE_MOBILE.src})`,
        }}
      >
        <Container data-qa-tag="common-questions-section-container">
          <div
            className={styles.splitBlock}
            data-qa-tag="common-questions-block"
          >
            <div
              className={styles.content}
              data-qa-tag="common-questions-content"
            >
              <RichText data-qa-tag="common-questions-richText">
                <h2 data-qa-tag="common-questions-heading">
                  PREGUNTAS FRECUENTES
                </h2>
                <h3 data-qa-tag="common-questions-heading-h3">
                  Preguntas para hacerle a su médico
                </h3>

                <p className="body-text" data-qa-tag="common-questions-intro">
                  Hable con su médico sobre los riesgos y beneficios de
                  NEXPLANON.
                </p>
              </RichText>
              <div
                className={styles.ctaWrapper}
                data-qa-tag="common-questions-cta-wrapper"
              >
                <ItemBreakpoint breakpoint="md">
                  <Button
                    type="primary"
                    href="/es-us/preguntas"
                    data-design-type="clickAction"
                    data-design-category="button_vd"
                    data-design-action="Button"
                    data-design-label="View All FAQs"
                    data-design-nori_id="Accordion"
                    data-design-module_name="Common questions"
                    data-design-module_no="07"
                    data-qa-tag="view-all-faqs-button"
                  >
                    Ver todas las Preguntas frecuentes
                  </Button>
                  <Button
                    type="primary"
                    href="/es-us/preguntas"
                    data-design-type="clickAction"
                    data-design-category="button_vd"
                    data-design-action="Button"
                    data-design-label="View All FAQs"
                    data-design-nori_id="Accordion"
                    data-design-module_name="Common questions"
                    data-design-module_no="07"
                    data-qa-tag="view-all-faqs-button"
                  >
                    Ver todas las Preguntas
                    <br />
                    frecuentes
                  </Button>
                </ItemBreakpoint>

                <Button
                  type="outlineSecondary2"
                  target="_blank"
                  rel="noopener"
                  href="/assets/static/Nexplanon-FAQ-spanish.pdf"
                  data-design-type="clickAction"
                  data-design-category="button_vd"
                  data-design-action="Download"
                  data-design-label="Download Questions"
                  data-design-nori_id="Accordion"
                  data-design-module_name="Common questions"
                  data-design-module_no="07"
                  data-qa-tag="download-questions-button"
                >
                  Descargar las preguntas
                </Button>
              </div>
            </div>
            <div className={styles.accordion} data-qa-tag="accordion-wrapper">
              <FAQ allowMultiple={true}>
                {FAQ_HOME_QUESTIONS.map((item, index) => (
                  <React.Fragment key={`question-${index}`}>
                    <FAQHeader
                      data-design-type="clickAction"
                      data-design-label={item.title}
                      data-design-nori_id="Accordion"
                      data-design-module_name="Common questions"
                      data-design-module_no="07"
                      data-design-element_no={`${
                        index < 9 ? '0' + (index + 1) : index + 1
                      }`}
                    >
                      {item.title}
                    </FAQHeader>
                    <div className={styles.faqContent}>{item.content}</div>
                  </React.Fragment>
                ))}
              </FAQ>
            </div>
            <p className={styles.caption} data-qa-tag="accordion-note">
              El implante que se muestra
              <br /> no es de tamaño real.
            </p>
            <Image
              className={styles.handImage}
              src={HAND_SHORT_IMAGE}
              width={338}
              height={377}
              alt=""
              data-qa-tag="accordion-image"
            />
          </div>
        </Container>
      </section>

      <FinderSimple
        data-qa-tag="finder-simple-nexplanon"
        designModuleNo="04"
        title="Lista PARA NEXPLANON"
        buttonLabel="Encuentra un médico"
        buttonHref="/what-is-nexplanon/#find-a-doctor"
      >
        Encuentra un profesional de la salud capacitado e inicia la
        conversación.
      </FinderSimple>
    </AltLayout>
  );
}
